import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from '../Services/config/http-error-handler.service';
import {BaseSvcService} from '../Services/config/base-svc.service';

@Injectable({
  providedIn: 'root',
})
export class SampleService {
  private handleError: HandleError;
  public url: string;
  public options;

  constructor(
    private http: HttpClient,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }

  /** GET heroes from the server */
  getQuestion(): Observable<any[]> {
    return this.http
      .get<any[]>(this.url + 'api/Question', this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  /* GET heroes whose name contains search term */
  searchHeroes(term: string): Observable<any[]> {
    term = term.trim();

    // Add safe, URL encoded search parameter if there is a search term
    const options = term ? { params: new HttpParams().set('name', term) } : {};

    return this.http
      .get<any[]>(this.url + 'api/GetSubjectTreeNodes', options)
      .pipe(catchError(this.handleError<any[]>('searchHeroes', [])));
  }

  Post(data: any): Observable<any> {
    return this.http
      .post<any>(this.url + 'api/GetSubjectTreeNodes', data, this.options)
      .pipe(catchError(this.handleError('Post', data)));
  }
}
